import { showPopup } from '@/functions/popup';

export function getToken(callback) {
  callback(localStorage.getItem('token'));
}

export function setToken(token, callback) {
  localStorage.setItem('token', token);
  callback();
}

export function removeToken() {
  localStorage.removeItem('token');
  reloadApp();
}

function reloadApp() {
  showPopup(
    'Время сессии истекло. Пожалуйста, авторизуйтесь повторно.',
    '',
    () => {
      if (window?.WebApp) {
        window.WebApp.close();
      }
    },
  );
}
